import React, { useContext } from "react";
import {
    Paper,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Grid,
} from "@mui/material";
import { ShoppingCart, PriceCheck } from "@mui/icons-material";
import { createOrders } from "../api/apiCalls";
import GlobalContext from "../contexts/globalcontext";

const BotTables = ({ tables }) => {
    const { sbAlert } = useContext(GlobalContext);

    const sendCreateOrders = async (instrument_name, side, price, quantity) => {
        // console.log(instrument_name, side, price, quantity);
        await createOrders(instrument_name, side, price, quantity);
        sbAlert("Order Sent", "success");
    };

    return (
        <Grid container spacing={2}>
            {tables.map((table, index) => {
                return (
                    <Grid
                        item
                        xs="auto"
                        sx={{ marginBottom: "10px" }}
                        key={index}
                    >
                        <TableContainer
                            component={Paper}
                            sx={{ width: 1000 }}
                            elevation={5}
                        >
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={9} align="center">
                                            <Typography variant="h6">
                                                &nbsp;{table.name} (Current
                                                Price: {table.currPrice})
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center">
                                            Buy Price
                                        </TableCell>
                                        <TableCell align="center">
                                            Buy Qty ({table.front})
                                        </TableCell>
                                        <TableCell align="center">
                                            Buy Qty ({table.front})
                                        </TableCell>
                                        <TableCell align="center">
                                            Get Qty ({table.front})
                                        </TableCell>
                                        <TableCell align="center">
                                            Buy Cost ({table.back})
                                        </TableCell>
                                        <TableCell align="center">
                                            Sell Price
                                        </TableCell>
                                        <TableCell align="center">
                                            Sell Qty ({table.front})
                                        </TableCell>
                                        <TableCell align="center">
                                            Sell Cost ({table.back})
                                        </TableCell>
                                        <TableCell align="center">
                                            Get Qty ({table.back})
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {table.table.map((row, indexrow) => (
                                        <TableRow key={indexrow}>
                                            <TableCell
                                                component="th"
                                                scope="row"
                                                align="center"
                                            >
                                                {row.buyPrice}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    endIcon={
                                                        row.buy2Status ? (
                                                            <PriceCheck />
                                                        ) : (
                                                            <ShoppingCart />
                                                        )
                                                    }
                                                    color="success"
                                                    disabled={
                                                        Boolean(
                                                            table.currPrice <
                                                                row.buyPrice
                                                        ) ||
                                                        row.buy2Status ||
                                                        row.buyStatus
                                                    }
                                                    onClick={() =>
                                                        sendCreateOrders(
                                                            table.name,
                                                            "BUY",
                                                            row.buyPrice,
                                                            row.buyQty2
                                                        )
                                                    }
                                                >
                                                    {row.buyQty2}
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    endIcon={
                                                        row.buyStatus ? (
                                                            <PriceCheck />
                                                        ) : (
                                                            <ShoppingCart />
                                                        )
                                                    }
                                                    color="success"
                                                    disabled={
                                                        Boolean(
                                                            table.currPrice <
                                                                row.buyPrice
                                                        ) ||
                                                        row.buyStatus ||
                                                        row.buy2Status
                                                    }
                                                    onClick={() =>
                                                        sendCreateOrders(
                                                            table.name,
                                                            "BUY",
                                                            row.buyPrice,
                                                            row.buyQty
                                                        )
                                                    }
                                                >
                                                    {row.buyQty}
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.buyGetQty}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.buyCost}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.sellPrice}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    color="error"
                                                    disabled={
                                                        Boolean(
                                                            table.currPrice >
                                                                row.sellPrice
                                                        ) || row.sellStatus
                                                    }
                                                    endIcon={
                                                        row.sellStatus ? (
                                                            <PriceCheck />
                                                        ) : (
                                                            <ShoppingCart />
                                                        )
                                                    }
                                                    onClick={() =>
                                                        sendCreateOrders(
                                                            table.name,
                                                            "SELL",
                                                            row.sellPrice,
                                                            row.sellQty
                                                        )
                                                    }
                                                >
                                                    {row.sellQty}
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.sellCost}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.sellGetQty}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default BotTables;
